var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-sign-in",on:{"click":function($event){return _vm.signIn()}}},[_c('img',{staticClass:"g-icon",attrs:{"src":require("@/assets/search.svg"),"alt":"G sign"}}),_c('p',[_vm._v("SignIn with Google")])])}
var staticRenderFns = []

export { render, staticRenderFns }